module.exports = __webpack_public_path__ + "img/6.b25972f1.png";